"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.KBarProvider = exports.KBarContext = void 0;
var useStore_1 = require("./useStore");
var React = __importStar(require("react"));
var InternalEvents_1 = require("./InternalEvents");
exports.KBarContext = React.createContext({});
var KBarProvider = function (props) {
    var contextValue = (0, useStore_1.useStore)(props);
    return (React.createElement(exports.KBarContext.Provider, { value: contextValue },
        React.createElement(InternalEvents_1.InternalEvents, null),
        props.children));
};
exports.KBarProvider = KBarProvider;
